<template>
  <div class="approval-chain-templates">
    <EditApprovalChainDialog
      :approvalChainTemplate="selectedApprovalChain"
      @close="closeDialog"
      v-if="isEditDialogOpen"
      :isOpen="isEditDialogOpen"
    />
    <div class="container col-lg-8 col-sm-12 mb-12">
      <BaseListToolbar
        title="Approval Chains"
        @search="updateSearchValue"
        hideSearchBar
      />
      <div v-if="isFetchingApprovalChains">
        <v-skeleton-loader v-for="i in 5" :key="i" s type="list-item-avatar" />
      </div>
      <div v-else>
        <v-list-item
          v-for="approvalChainTemplate in approvalChainTemplates"
          :key="approvalChainTemplate.id"
          @click="handleSelect(approvalChainTemplate)"
        >
          <ApprovalChainTemplateItem
            :approvalChainTemplate="approvalChainTemplate"
          />
        </v-list-item>
      </div>
      <BaseFooter>
        <Permissioned section="settings" class="d-flex actions-bar">
          <NewApprovalChainAction permissions="approval-chains.edit" />
        </Permissioned>
      </BaseFooter>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { APPROVAL_CHAIN_TEMPLATE_NAMESPACE } from "@/store/modules/organisations/organisation-approval-chain-templates";
import { FETCH_APPROVAL_CHAIN_TEMPLATES } from "@/store/modules/organisations/organisation-approval-chain-templates/actions";
import { copyState } from "@/utils/helpers";
import ApprovalChainTemplateItem from "@/views/settings/components/approval-chain-templates/components/ApprovalChainTemplateItem";
import BaseFooter from "@/components/common/BaseFooter";
import NewApprovalChainAction from "@/views/settings/components/approval-chain-templates/components/actions/NewApprovalChainTemplateAction";
import EditApprovalChainDialog from "@/views/settings/components/approval-chain-templates/components/dialogs/EditApprovalChainTemplateDialog";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import { size } from "lodash";
import Permissioned from "@/components/common/Permissioned";

const { mapActions, mapState } = createNamespacedHelpers(
  APPROVAL_CHAIN_TEMPLATE_NAMESPACE
);

export default {
  components: {
    ApprovalChainTemplateItem,
    BaseFooter,
    NewApprovalChainAction,
    EditApprovalChainDialog,
    BaseListToolbar,
    Permissioned
  },
  async created() {
    await this.loadApprovalChainTemplates();
  },
  data() {
    return {
      isEditDialogOpen: false,
      selectedApprovalChain: {},
      searchText: ""
    };
  },
  computed: {
    ...mapState(
      copyState(["approvalChainTemplates", "isFetchingApprovalChains"])
    ),
    requestParams() {
      return {
        filter: {
          ...(size(this.searchText) && { search: this.searchText })
        }
      };
    }
  },
  methods: {
    ...mapActions({
      fetchApprovalChainTemplates: FETCH_APPROVAL_CHAIN_TEMPLATES
    }),
    handleSelect(approvalChainTemplate) {
      this.selectedApprovalChain = approvalChainTemplate;
      this.isEditDialogOpen = true;
    },
    async loadApprovalChainTemplates() {
      await this.fetchApprovalChainTemplates(this.requestParams);
    },
    closeDialog() {
      this.isEditDialogOpen = false;
    },
    updateSearchValue(text) {
      this.searchText = text;
      this.loadApprovalChainTemplates();
    }
  }
};
</script>

<style lang="scss"></style>
